import { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useAuth } from "../../../hooks/useAuth";

export function useGiftees() {
  const { currentUser } = useAuth();
  const [giftees, setGiftees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser) {
      setGiftees([]);
      setLoading(false);
      return;
    }

    const colRef = collection(db, "users", currentUser.uid, "giftees");
    // createdAt is set with serverTimestamp(); okay to order by desc
    const q = query(colRef, orderBy("createdAt", "desc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setGiftees(items);
        setLoading(false);
      },
      (err) => {
        console.error("useGiftees error:", err);
        setError("Failed to load giftees.");
        setLoading(false);
      }
    );

    return () => unsub();
  }, [currentUser]);

  return { giftees, loading, error };
}
